import * as React from 'react';

import { SearchCriteriaModel } from '../../models/search-criteria-model';

import { SearchCriteriaContext } from './search-criteria-context';

export interface SearchCriteriaProviderProps {
  searchCriteria: SearchCriteriaModel;
}

export const SearchCriteriaProvider: React.FC<SearchCriteriaProviderProps> = ({ children, searchCriteria }) => (
  <SearchCriteriaContext.Provider value={searchCriteria}>{children}</SearchCriteriaContext.Provider>
);
